import React from "react"
import okImg from "../../../../../static/pic/ok.png"
import Styles from "./loading.less"
import {Lottie} from "@crello/react-lottie"
import loadingCheck from "../../../../../static/pic/小K状态/检测状态/检测状态.json"
import loadingSuccess from "../../../../../static/pic/小K状态/完成状态/完成状态.json"
import loadingWelcome from "../../../../../static/pic/小K状态/欢迎状态/欢迎状态.json"
import loadingError from "../../../../../static/pic/小K状态/错误状态/错误状态.json"
import loadingStop from "../../../../../static/pic/小K状态/静止状态/静止状态.json"
import loadingDefault from "../../../../../static/pic/小K状态/默认状态/默认状态.json"
import {connect, useDispatch} from "react-redux"
import {VIEWTYPE} from "../../../../util/utilData"
import {ReducerState} from "../../../../../reducer/interface/baseInterface"
import {PollingSteps} from "../../../../../reducer/interface/controlInterface"
import {Timer} from "../../../../../function/base/timer"
const loadingStep = [loadingCheck, loadingCheck, loadingCheck, loadingCheck, loadingSuccess]

interface LoadingProps {
    viewType: string
    pollingSteps: PollingSteps
    timer: Timer
}

const Loading: React.FunctionComponent<LoadingProps> = (props) => {
    const dispatch = useDispatch()
    // const getStyle = (status: boolean) => {
    //     if (status) {
    //         return {
    //             width: 24,
    //             height: 24,
    //             backgroundImage: `url(${okImg})`,
    //             border: "0px solid",
    //             borderRadius: "50%",
    //         }
    //     }
    // }
    return (
        <div className={Styles.waitingBox}>
            <Lottie
                width="120px"
                height="120px"
                className={Styles["ss-lottie-container"]}
                config={{animationData: loadingStep[props.timer.getActiveStep()], loop: true, autoplay: true}}
            />
            <div className={Styles.step}>
                <div className={Styles.text}>文档差异分析中，请稍候......</div>
            </div>
            {/* <div className={Styles.step}>
                <div className={Styles.pollingSteps} style={getStyle(props.pollingSteps.step1)} />
                <div className={Styles.text}>文档版面分析</div>
            </div>
            <div className={Styles.step}>
                <div className={Styles.pollingSteps} style={getStyle(props.pollingSteps.step2)} />
                <div className={Styles.text}>文本检测</div>
            </div>
            <div className={Styles.step}>
                <div className={Styles.pollingSteps} style={getStyle(props.pollingSteps.step3)} />
                <div className={Styles.text}>表格检测</div>
            </div>
            <div className={Styles.step}>
                <div className={Styles.pollingSteps} style={getStyle(props.pollingSteps.step4)} />
                <div className={Styles.text}>印章检测</div>
            </div>
            <div className={Styles.step}>
                <div className={Styles.pollingSteps} style={getStyle(props.pollingSteps.step5)} />
                <div className={Styles.text}>差异结果统计</div>
            </div> */}
            <div
                onClick={() => {
                    dispatch({type: "returnOperate", payload: ""})
                    dispatch({type: "activeView", payload: "operate"})
                    dispatch({type: "setViewType", payload: VIEWTYPE.HISTORY})
                }}
                style={{
                    display: props.viewType === VIEWTYPE.SHOW || props.viewType === VIEWTYPE.TEST ? "none" : "flex",
                }}
                className={Styles.operationBG}
            >
                后台运行
            </div>
        </div>
    )
}
export default connect((state: ReducerState) => {
    return {
        viewType: state.global.viewType,
        pollingSteps: state.control.pollingSteps,
        timer: state.control.timer,
    }
})(Loading)
